<template>
  <div class="login-form">
    <el-form class="public-big-form" ref="form" :model="form" :rules="rules">
      <el-form-item prop="account" :error="formError.account">
        <el-input v-model="form.account" size="small" placeholder="请输入考生账号" clearable @keyup.native.enter="submit"></el-input>
      </el-form-item>
      <el-form-item prop="passwd" :error="formError.passwd">
        <el-input v-model="form.passwd" size="small" placeholder="请输入考生密码" type="password" show-password clearable @keyup.native.enter="submit"></el-input>
      </el-form-item>
      <el-form-item prop="captcha_value" :error="formError.captcha_value">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-input v-model="form.captcha_value" size="small" placeholder="请输入计算结果" clearable @keyup.native.enter="submit"></el-input>
          </el-col>
          <el-col :span="8">
            <div class="captcha-wrapper" @click="getCaptcha">
              <img :src="captcha_img" alt title="点击更换验证码" />
            </div>
          </el-col>
          <el-col :span="4">
            <span @click="getCaptcha" style="cursor:pointer">更换</span>
          </el-col>
        </el-row>
      </el-form-item>
      <p style="text-align: right;font-size: 14px;">请在左侧输入框输入图片上加减乘除计算后的结果数字</p>
      <el-form-item>
        <el-button type="primary" @click="submit" class="login-button" :loading="btn_loading">登录</el-button>
      </el-form-item>
      <el-form-item>
        <div class="other-login">
          <a href="./admin" class="item">
            <i class="iconfont icon-id-card"></i>
            <span class="text">承办机构点此登录</span>
          </a>
        </div>
      </el-form-item>
      <!-- <el-form-item class="hidden-xs-only">
				<div class="other-login">
					<div class="item">
						<i class="iconfont icon-wechat"></i>
						<p class="text">微信登录</p>
					</div>
					<div class="item">
						<i class="iconfont icon-id-card"></i>
						<p class="text">统一身份认证登录</p>
					</div>
				</div>
			</el-form-item>-->
    </el-form>
  </div>
</template>
<script>
import { captcha } from "@/api/user";
export default {
  data() {
    return {
      btn_loading: false,
      form: {
        account: "",
        passwd: "",
        captcha_key: "",
        captcha_value: "",
        force: 1,
      },
      captcha_img: "",
      formError: {},

      rules: {
        account: [
          {
            required: true,
            message: "请输入考生账号",
            trigger: "blur",
          },
        ],
        passwd: [
          {
            required: true,
            message: "请输入考生密码",
            trigger: "blur",
          },
        ],
        captcha_value: [
          {
            required: true,
            message: "请输入计算结果",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getCaptcha();
  },
  methods: {
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btn_loading = true;

          const ajaxData = {
            ...this.form,
            captcha_value: Number(this.form.captcha_value),
          };

          this.$store
            .dispatch("login", ajaxData)
            .then((res) => {
              if (
                //学生登陆成功
                res &&
                res.code === 200 &&
                res.data.member_type === "student"
              ) {
                this.$router.push("/");
              } else if (
                //其他账户登录成功，主动报错
                res &&
                res.code === 200 &&
                res.data.member_type !== "student"
              ) {
                this.$notify.error({
                  message: "用户名或密码错误",
                });
                this.getCaptcha();
              } else if (res && res.errors) {
                //表单格式错误
                this.formError = this.$transformError(res.errors);
                this.getCaptcha();
              } else {
                //其他错误
                this.$notify.error({
                  message: res.message,
                });
                this.getCaptcha();
              }
            })
            .finally(() => {
              this.btn_loading = false;
            });
        }
      });
    },
    getCaptcha() {
      this.form.captcha_key = "";
      this.form.captcha_value = "";
      captcha().then((res) => {
        if (res && res.code === 200) {
          this.captcha_img = res.data.img;
          this.form.captcha_key = res.data.key;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.login-form {
  width: 80%;
  margin: 30px auto 0;
  .other-login {
    .item {
      .iconfont {
        display: inline-block;
        width: 26px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        color: #fff;
        background: #c1c1c1;
        border-radius: 50%;
        margin: 0 auto;
        margin-right: 8px;
        font-size: 16px;
        transition: all 0.3s;
      }
      .text {
        font-size: 16px;
        color: #c1c1c1;
        white-space: nowrap;
        margin-top: 10px;
        transition: all 0.3s;
        text-align: center;
      }
    }
  }
}
</style>
